import React from 'react'
import './background.scss'
import './stars.scss'
import './less-stars.scss'
import './even-less-stars.scss'

export const CLASS_NAME_STAR = 'stars'
export const CLASS_NAME_LESS_STAR = 'less-stars'
export const CLASS_NAME_EVEN_LESS_STAR = 'even-less-stars'

export default function getStarry ({ mode } = {}) {
  let starClassName = CLASS_NAME_STAR
  switch (mode) {
    case 'less':
      starClassName = CLASS_NAME_LESS_STAR
      break
    case 'even-less':
      starClassName = CLASS_NAME_EVEN_LESS_STAR
      break
    default:
  }
  return {
    className: 'starry',
    starClassName,
    children: (
      <>
        <div
          id={`${getClassPrefix({ mode })}stars`}
          className={starClassName}
        />
        <div
          id={`${getClassPrefix({ mode })}stars2`}
          className={starClassName}
        />
        <div
          id={`${getClassPrefix({ mode })}stars3`}
          className={starClassName}
        />
      </>
    ),
  }
}

function getClassPrefix ({ mode }) {
  let prefix = ''
  switch (mode) {
    case 'less':
      prefix = 'less-'
      break
    case 'even-less':
      prefix = 'even-less-'
      break
    default:
  }

  return prefix
}
